<div class="main-container">
  <div class="grid-container" id="f304-grid-container" style="height:calc(100% - 55px);">
    <div class="top-toolbar">
      <div class="float-left ml-2">
        @if (taxyearLoaded) {
          <ap-dropdown class="tax-year-dropdown" [list]="taxYearItems" [selectType]="'single'" [title]="'Tax Year'"
            [hideTitleOnInput]="true" [inputAriaLabel]="'Tax Year'" [(ngModel)]="selectedTaxYearItem"
            (onSelect)="onTaxYearChanged($event)">
            @for (item of taxYearItems; track item.value) {
              <ap-dropdown-list-item #dropdownListItem [item]="item" [ariaLabel]="setTaxYearAriaLabel(item)"
                (onSelectItem)="onTaxYearSelectItem($event)"></ap-dropdown-list-item>
            }
          </ap-dropdown>
        }
        <gtw-df-me-dropdown class="top-filter-select me-dropdown-label mr-2" [customActionCode]="32136"
          (selectedMes)="selectedMeChanged($event)"></gtw-df-me-dropdown>
        <ap-button [compact]="true" [btnType]="'primary'" [label]="'Filter'" class="ap-mr-spacing-3"
          (onClick)="refresh()"></ap-button>
        <button class="export-btn" (click)="exportToExcel()">
          <i class="Appkit4-icon icon-save-outline"></i>
          Export to Excel
        </button>
      </div>
    </div>

    <div class="dst-mat-grid-layout">
      @if (loading) {
        <div class="dst-mat-grid-loading">
          <mat-spinner [diameter]="40"></mat-spinner>
        </div>
      }
      <div class="dst-mat-grid">
        <table mat-table [dataSource]="dataSource" [fixedLayout]="true" matSort class="dst-mat-table">
          <ng-container matColumnDef="TAXYEAR">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getDstColStyle(getColByField('TAXYEAR'))">
              {{ getColByField('TAXYEAR').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getDstColStyle(getColByField('TAXYEAR'))">
              <span>{{ rowData.TAXYEAR }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="STATEMENTID">
            <th mat-header-cell *matHeaderCellDef mat-sort-header
              [ngStyle]="getDstColStyle(getColByField('STATEMENTID'))">
              {{ getColByField('STATEMENTID').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" style="overflow: visible;"
              [ngStyle]="getDstColStyle(getColByField('STATEMENTID'))">
              <a href="javascript:void(0);" (click)="showViewUpdateStatement(rowData)">
                <span>{{ rowData.STATEMENTID }}</span>
              </a>
            </td>
          </ng-container>

          <ng-container matColumnDef="STATEMENTNAME">
            <th mat-header-cell *matHeaderCellDef mat-sort-header
              [ngStyle]="getDstColStyle(getColByField('STATEMENTNAME'))">
              {{ getColByField('STATEMENTNAME').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" class="text-pre-wrap"
              [ngStyle]="getDstColStyle(getColByField('STATEMENTNAME'))">
              <span>{{ rowData.STATEMENTNAME }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="PRIMARYBUSINESS">
            <th mat-header-cell *matHeaderCellDef mat-sort-header
              [ngStyle]="getDstColStyle(getColByField('PRIMARYBUSINESS'))">
              {{ getColByField('PRIMARYBUSINESS').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getDstColStyle(getColByField('PRIMARYBUSINESS'))">
              <span>{{ rowData.PRIMARYBUSINESS }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="PRIMARYLEID">
            <th mat-header-cell *matHeaderCellDef mat-sort-header
              [ngStyle]="getDstColStyle(getColByField('PRIMARYLEID'))">
              {{ getColByField('PRIMARYLEID').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getDstColStyle(getColByField('PRIMARYLEID'))">
              <span>{{ rowData.PRIMARYLEID }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="PRIMARYENTITY">
            <th mat-header-cell *matHeaderCellDef mat-sort-header
              [ngStyle]="getDstColStyle(getColByField('PRIMARYENTITY'))">
              {{ getColByField('PRIMARYENTITY').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getDstColStyle(getColByField('PRIMARYENTITY'))">
              <span>{{ rowData.PRIMARYENTITY }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="PRIMARYGEGECS">
            <th mat-header-cell *matHeaderCellDef mat-sort-header
              [ngStyle]="getDstColStyle(getColByField('PRIMARYGEGECS'))">
              {{ getColByField('PRIMARYGEGECS').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getDstColStyle(getColByField('PRIMARYGEGECS'))">
              <span>{{ rowData.PRIMARYGEGECS }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="SECONDARYLEID">
            <th mat-header-cell *matHeaderCellDef mat-sort-header
              [ngStyle]="getDstColStyle(getColByField('SECONDARYLEID'))">
              {{ getColByField('SECONDARYLEID').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getDstColStyle(getColByField('SECONDARYLEID'))">
              <span>{{ rowData.SECONDARYLEID }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="SECONDARYENTITY">
            <th mat-header-cell *matHeaderCellDef mat-sort-header
              [ngStyle]="getDstColStyle(getColByField('SECONDARYENTITY'))">
              {{ getColByField('SECONDARYENTITY').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getDstColStyle(getColByField('SECONDARYENTITY'))">
              <span>{{ rowData.SECONDARYENTITY }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="TARGET_LEID">
            <th mat-header-cell *matHeaderCellDef mat-sort-header
              [ngStyle]="getDstColStyle(getColByField('TARGET_LEID'))">
              {{ getColByField('TARGET_LEID').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getDstColStyle(getColByField('TARGET_LEID'))">
              <span>{{ rowData.TARGET_LEID }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="SHAREX">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getDstColStyle(getColByField('SHAREX'))">
              {{ getColByField('SHAREX').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getDstColStyle(getColByField('SHAREX'))">
              <span>{{ rowData.SHAREX }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="SHAREY">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getDstColStyle(getColByField('SHAREY'))">
              {{ getColByField('SHAREY').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getDstColStyle(getColByField('SHAREY'))">
              <span>{{ rowData.SHAREY }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="PERCENTAGEX">
            <th mat-header-cell *matHeaderCellDef mat-sort-header
              [ngStyle]="getDstColStyle(getColByField('PERCENTAGEX'))">
              {{ getColByField('PERCENTAGEX').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getDstColStyle(getColByField('PERCENTAGEX'))">
              <span>{{ rowData.PERCENTAGEX != null ? rowData.PERCENTAGEX + '%' : '' }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="PERCENTAGEY">
            <th mat-header-cell *matHeaderCellDef mat-sort-header
              [ngStyle]="getDstColStyle(getColByField('PERCENTAGEY'))">
              {{ getColByField('PERCENTAGEY').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getDstColStyle(getColByField('PERCENTAGEY'))">
              <span>{{ rowData.PERCENTAGEY != null ? rowData.PERCENTAGEY + '%' : '' }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="STOCK_TYPE_NAME">
            <th mat-header-cell *matHeaderCellDef mat-sort-header
              [ngStyle]="getDstColStyle(getColByField('STOCK_TYPE_NAME'))">
              {{ getColByField('STOCK_TYPE_NAME').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getDstColStyle(getColByField('STOCK_TYPE_NAME'))">
              <span>{{ rowData.STOCK_TYPE_NAME }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="CURRENCY_NAME">
            <th mat-header-cell *matHeaderCellDef mat-sort-header
              [ngStyle]="getDstColStyle(getColByField('CURRENCY_NAME'))">
              {{ getColByField('CURRENCY_NAME').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getDstColStyle(getColByField('CURRENCY_NAME'))">
              <span>{{ rowData.CURRENCY_NAME }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="DESCVAL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getDstColStyle(getColByField('DESCVAL'))">
              {{ getColByField('DESCVAL').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getDstColStyle(getColByField('DESCVAL'))">
              <span>{{ rowData.DESCVAL }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="BASIS_NAME">
            <th mat-header-cell *matHeaderCellDef mat-sort-header
              [ngStyle]="getDstColStyle(getColByField('BASIS_NAME'))">
              {{ getColByField('BASIS_NAME').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getDstColStyle(getColByField('BASIS_NAME'))">
              <span>{{ rowData.BASIS_NAME }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="BASISAMT">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getDstColStyle(getColByField('BASISAMT'))">
              {{ getColByField('BASISAMT').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getDstColStyle(getColByField('BASISAMT'))">
              <span>{{ rowData.BASISAMT | currency }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="FMVAMT">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getDstColStyle(getColByField('FMVAMT'))">
              {{ getColByField('FMVAMT').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getDstColStyle(getColByField('FMVAMT'))">
              <span>{{ rowData.FMVAMT | currency }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="LIQUIDATIONDATE">
            <th mat-header-cell *matHeaderCellDef mat-sort-header
              [ngStyle]="getDstColStyle(getColByField('LIQUIDATIONDATE'))">
              {{ getColByField('LIQUIDATIONDATE').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getDstColStyle(getColByField('LIQUIDATIONDATE'))">
              <span>{{ rowData.LIQUIDATIONDATE }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="ISREVIEWED">
            <th mat-header-cell *matHeaderCellDef mat-sort-header
              [ngStyle]="getDstColStyle(getColByField('ISREVIEWED'))">
              {{ getColByField('ISREVIEWED').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" class="item-aligned"
              [ngStyle]="getDstColStyle(getColByField('ISREVIEWED'))">
              <ap-checkbox [styleClass]="'a-mx-10'" [ngModel]="rowData.ISREVIEWED === 1"
                (onChange)="statementReviewedChange($event, rowData)"
                [disabled]="(dstSharedService.user.roleLevel < 2) || dstSharedService.isFiled">
              </ap-checkbox>
            </td>
          </ng-container>

          <ng-container matColumnDef="ISQARSTR">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getDstColStyle(getColByField('ISQARSTR'))">
              {{ getColByField('ISQARSTR').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" class="text-pre-wrap"
              [ngStyle]="getDstColStyle(getColByField('ISQARSTR'))">
              <span>{{ rowData.ISQARSTR }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="MODIFIEDBY">
            <th mat-header-cell *matHeaderCellDef mat-sort-header
              [ngStyle]="getDstColStyle(getColByField('MODIFIEDBY'))">
              {{ getColByField('MODIFIEDBY').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" class="text-pre-wrap"
              [ngStyle]="getDstColStyle(getColByField('MODIFIEDBY'))">
              <span>{{ rowData.MODIFIEDBY }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="MODIFIEDON">
            <th mat-header-cell *matHeaderCellDef mat-sort-header
              [ngStyle]="getDstColStyle(getColByField('MODIFIEDON'))">
              {{ getColByField('MODIFIEDON').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" class="text-pre-wrap"
              [ngStyle]="getDstColStyle(getColByField('MODIFIEDON'))">
              <span>{{ rowData.MODIFIEDON | date:'yyyy/MM/dd' }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="CREATEDBY">
            <th mat-header-cell *matHeaderCellDef mat-sort-header
              [ngStyle]="getDstColStyle(getColByField('CREATEDBY'))">
              {{ getColByField('CREATEDBY').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" class="text-pre-wrap"
              [ngStyle]="getDstColStyle(getColByField('CREATEDBY'))">
              <span>{{ rowData.CREATEDBY }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="CREATEDON">
            <th mat-header-cell *matHeaderCellDef mat-sort-header
              [ngStyle]="getDstColStyle(getColByField('CREATEDON'))">
              {{ getColByField('CREATEDON').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" class="text-pre-wrap"
              [ngStyle]="getDstColStyle(getColByField('CREATEDON'))">
              <span>{{ rowData.CREATEDON | date:'yyyy/MM/dd' }}</span>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
    </div>
  </div>

  @if (showModalViewer) {
    <dst-disc-modal-viewer [rowObject]="activeRow" (afterModalClosed)="afterModalClosed()">
    </dst-disc-modal-viewer>
  }
</div>
